import { useCallback } from 'react';
import { gql, useMutation } from '@apollo/client';

const query = gql`
  mutation ForceLogout($idnumber: String!) {
    forceLogout(idnumber: $idnumber)
  }
`;

interface Args {
  idnumber: string;
}

type HookReturns = [(idnumber: string) => Promise<void>, { loading: boolean }];

export default function useForceLogout(): HookReturns {
  const [mutate, { loading, error }] = useMutation<unknown, Args>(query);
  if (error != null) throw error;

  const action = useCallback(
    async (idnumber: string): Promise<void> => {
      await mutate({ variables: { idnumber } });
    },
    [mutate]
  );

  return [action, { loading }];
}
